import React, {useEffect} from "react";

import {Card, Col, Form, Input, Label, Row, Button} from "reactstrap";
import {IoIosArrowBack} from "react-icons/io";

import {useSelector} from "react-redux";
import * as actions from "../../../store/modules/layoutParametrizacao/actions";
import * as controller from "../../../controllers/layoutParametrizacaoController";

import {Mapeamento} from "../components/Mapeamento";
import {Select, Switch} from "../../../components/Inputs/Input";
import Breadcrumb from "../../../components/breadcrumbs";

import "../styles.css";
import {notifyWarn} from "../../../components/message/message";

export function Register() {
    const {
        layoutBeingCreated,
        tiposArquivo,
        tiposComissao,
        instituicoesFinanceira,
        activeTab,
        layoutsCamposEquivalentes,
    } = useSelector((state) => state.layoutParametrizacao);

    useEffect(() => {
        actions.clearMapeamento();
        actions.clearLayoutBeingCreated();
        actions.clearDetalhamento();
        actions.clearStatus();
    }, []);

    useEffect(() => {
        (async () => {
            const tiposArquivo = await controller.getTiposArquivo();
            const instituicoesFinanceiras =
                await controller.getInstituicoesFinanceira();
            const tiposComissao = await controller.getTiposComissao();

            actions.setTipoArquivos(tiposArquivo);
            actions.setInstituicoes(instituicoesFinanceiras);
            actions.setTiposComissao(tiposComissao);
        })();
    }, []);

    function clearPageData() {
        actions.clearLayoutBeingCreated();
        actions.clearMapeamento();
        actions.clearDetalhamento();
        actions.clearStatus();
    }

    async function handleSalvar() {
        const isSuccessed = await controller.createLayout(layoutBeingCreated);

        if (isSuccessed) {
            clearPageData();
            actions.setActiveTab("Search");
        }
    }

    function handleVoltar() {
        clearPageData();
        actions.setActiveTab("Search");
    }

    async function handleTipoArquivoChange(tipoArquivoId) {
        actions.clearMapeamento();
        actions.clearDetalhamento();
        actions.clearStatus();
        actions.cleanLayoutsCamposEquivalentes();
        actions.setLayoutBeingCreated({
            ...layoutBeingCreated,
            tipoArquivoId: tipoArquivoId,
        });

        if (tipoArquivoId !== "0") {
            const allLayoutsCamposEquivalentes =
                await controller.getAllLayoutsCamposEquivalentes(tipoArquivoId);
            let camposEquivalentes = await controller.getLayoutsCamposEquivalentes(
                tipoArquivoId
            );

            actions.setLayoutsCamposEquivalentes(camposEquivalentes ?? []);
            actions.setAllLayoutsCamposEquivalentes(allLayoutsCamposEquivalentes ?? []);
        }
    }

    function handleTipoComissaoChange(e) {
        actions.setLayoutBeingCreated({
            ...layoutBeingCreated,
            tipoComissaoBancoId: e.value,
        });

        // clear detalhamentos from mapeamento
        actions.setMapeamento("detalhes", []);
    }

    async function handleValidaCpf(){
       await actions.setLayoutBeingCreated({
            ...layoutBeingCreated,
            validaCpf: !layoutBeingCreated.validaCpf,
        });

        if (!layoutBeingCreated.validaCpf){
            if (layoutBeingCreated.tipoArquivoId !== "0") {
                const allLayoutsCamposEquivalentes =
                    await controller.getAllLayoutsCamposEquivalentes(layoutBeingCreated.tipoArquivoId);
                const camposEquivalentes = await controller.getLayoutsCamposEquivalentes(
                    layoutBeingCreated.tipoArquivoId
                );

                actions.setLayoutsCamposEquivalentes(camposEquivalentes ?? []);
                actions.setAllLayoutsCamposEquivalentes(allLayoutsCamposEquivalentes ?? []);
            }
        } else {
            let possuiCpfRegistrado = layoutBeingCreated.layoutPlanilhaParametros.filter((layout) => {
                if (layout.layoutPlanilhaCamposEquivalenteId === "4ad5278b-d132-445b-b11c-fa4f552356f2")
                    return layout;
            });

            if (possuiCpfRegistrado.length !== 0){
                notifyWarn("CPF Já mapeado, favor remover do mapeamento");
                await actions.setLayoutBeingCreated({
                    ...layoutBeingCreated,
                    validaCpf: true,
                });
                return;
            }

            let novaListaLayouts =
                layoutsCamposEquivalentes.filter(campo => campo.id !== "4ad5278b-d132-445b-b11c-fa4f552356f2");

            actions.setLayoutsCamposEquivalentes(novaListaLayouts ?? []);
        }
    }
    function handleValidaProduto(){
        actions.setLayoutBeingCreated({
            ...layoutBeingCreated,
            validaProduto: !layoutBeingCreated.validaProduto,
        });
        actions.setMapeamento("layoutPlanilhaCamposEquivalenteId", "0");
    }

    //"4ad5278b-d132-445b-b11c-fa4f552356f2" <== CPF Cliente
    return (
        <>
            <Col>
                <Breadcrumb activeTab={activeTab}/>
                <Card className="mb-2 mt-2">
                    <Form>
                        <Col className="pt-2 pb-2">
                            <Button
                                onClick={() => {
                                    handleVoltar();
                                }}
                                style={{width: "127px", color: "white"}}
                                className="purpleButton"
                            >
                                <IoIosArrowBack
                                    style={{
                                        marginTop: "3px",
                                        float: "left",
                                    }}
                                />
                                Voltar
                            </Button>

                            <Button
                                onClick={() => {
                                    handleSalvar();
                                }}
                                style={{
                                    width: "242px",
                                    float: "right",
                                }}
                                className="purpleButton"
                            >
                                Salvar Cadastro
                            </Button>
                        </Col>
                    </Form>
                </Card>
            </Col>
            <Col>
                <Card className="radius pb-5">
                    <Col>
                        <Col className="pt-2 mt-4 mb-4 ">
                            <p style={{fontSize: "18px", color: "var(--color-preto)"}}>
                                Preencha os campos para cadastrar um novo Layout de
                                parametrização
                            </p>
                        </Col>
                        <Form>
                            <Col>
                                <Row>
                                    <Col md={4}>
                                        <Label
                                            for="convenio"
                                            style={{fontWeight: "700", color: "var(--color-preto)"}}
                                        >
                                            Descrição do layout
                                        </Label>
                                        <Input
                                            type="text"
                                            placeholder="Digite aqui..."
                                            value={layoutBeingCreated.descricao}
                                            onChange={(e) =>
                                                actions.setLayoutBeingCreated({
                                                    ...layoutBeingCreated,
                                                    descricao: e.target.value.toUpperCase(),
                                                })
                                            }
                                            style={{height: "37px"}}
                                        />
                                    </Col>
                                    <Col md={4}>
                                        <Label
                                            for="convenio"
                                            style={{fontWeight: "700", color: "var(--color-preto)"}}
                                        >
                                            Tipo do arquivo
                                        </Label>
                                        <Select
                                            first="Selecione"
                                            value={{value: layoutBeingCreated.tipoArquivoId}}
                                            select={{value: "id", label: "descricao"}}
                                            options={tiposArquivo}
                                            onChange={(e) => {
                                                handleTipoArquivoChange(e.value);
                                            }}
                                            autoComplete="off"
                                            disabled={
                                                layoutBeingCreated.layoutPlanilhaParametros.length === 0
                                                    ? false
                                                    : true
                                            }
                                        />
                                    </Col>
                                    <Col md={4}>
                                        <Label
                                            for="convenio"
                                            style={{fontWeight: "700", color: "var(--color-preto)"}}
                                        >
                                            Instituição Financeira
                                        </Label>
                                        <Select
                                            first="Selecione"
                                            value={{value: layoutBeingCreated.bancoId}}
                                            select={{value: "id", label: "nome"}}
                                            options={instituicoesFinanceira}
                                            onChange={(e) =>
                                                actions.setLayoutBeingCreated({
                                                    ...layoutBeingCreated,
                                                    bancoId: e.value,
                                                })
                                            }
                                            autoComplete="off"
                                        />
                                    </Col>
                                </Row>
                                <Row className="mt-4">
                                    {layoutBeingCreated.tipoArquivoId.toUpperCase() ===
                                        "4898DDC8-C0CB-49D8-BB72-EA946FB7963D" && (
                                            <Col md={4}>
                                                <Label
                                                    for="convenio"
                                                    style={{
                                                        fontWeight: "700",
                                                        color: "var(--color-preto)",
                                                    }}
                                                >
                                                    Tipo Comissão
                                                </Label>
                                                <Select
                                                    first="Selecione"
                                                    value={{
                                                        value: layoutBeingCreated.tipoComissaoBancoId,
                                                    }}
                                                    select={{value: "id", label: "descricao"}}
                                                    options={tiposComissao}
                                                    onChange={(e) => handleTipoComissaoChange(e)}
                                                    autoComplete="off"
                                                    disabled={layoutBeingCreated.layoutPlanilhaParametros.some(
                                                        (parametro) => parametro.detalhes.length > 0
                                                    )}
                                                />
                                            </Col>
                                        )}
                                    <Col md={4}>
                                        <Label
                                            for="convenio"
                                            style={{fontWeight: "700", color: "var(--color-preto)"}}
                                        >
                                            Número Aba
                                        </Label>
                                        <Input
                                            placeholder="Digite aqui..."
                                            value={layoutBeingCreated.nomeAba}
                                            onChange={(e) =>
                                                actions.setLayoutBeingCreated({
                                                    ...layoutBeingCreated,
                                                    nomeAba: e.target.value,
                                                })
                                            }
                                            style={{height: "37px"}}
                                        />
                                    </Col>
                                    {layoutBeingCreated.tipoArquivoId.toUpperCase() ===
                                        "4898DDC8-C0CB-49D8-BB72-EA946FB7963D" && (
                                            <Col
                                                md={4}
                                                style={{
                                                    display: "flex",
                                                    justifyContent: "end",
                                                    marginLeft: "auto",
                                                }}
                                            ><>
                                            <Label style={{
                                                fontWeight: "700",
                                                color: "var(--color-preto)",
                                                whiteSpace: "nowrap",
                                              }}>
                                                Valida Produto
                                              </Label>
                                              <div style={{marginLeft: "-50px", marginTop: "25px"}}>
                                                <Switch
                                                    className="switch"
                                                    checked={layoutBeingCreated.validaProduto}
                                                    onChange={() => handleValidaProduto()}
                                                />
                                              </div>
                                            </>
                                                <>
                                                    <Label style={{
                                                        fontWeight: "700",
                                                        color: "var(--color-preto)",
                                                        whiteSpace: "nowrap",
                                                    }}>
                                                        Valida CPF
                                                    </Label>
                                                    <div style={{marginLeft: "-50px", marginTop: "25px"}}>
                                                        <Switch
                                                            className="switch"
                                                            checked={layoutBeingCreated.validaCpf}
                                                            onChange={() => handleValidaCpf()}
                                                        />
                                                    </div>
                                                </>
                                                <>
                                                    <Label
                                                        style={{
                                                            fontWeight: "700",
                                                            color: "var(--color-preto)",
                                                            whiteSpace: "nowrap",
                                                        }}
                                                    >
                                                        Individual
                                                    </Label>
                                                    <div style={{marginLeft: "-50px", marginTop: "25px"}}>
                                                        <Switch
                                                            className="switch"
                                                            checked={layoutBeingCreated.isIndividual}
                                                            onChange={(e) =>
                                                                actions.setLayoutBeingCreated({
                                                                    ...layoutBeingCreated,
                                                                    isIndividual: !layoutBeingCreated.isIndividual,
                                                                })
                                                            }
                                                        />
                                                    </div>
                                                </>
                                                <>
                                                    <Label
                                                        style={{
                                                            fontWeight: "700",
                                                            color: "var(--color-preto)",
                                                            whiteSpace: "nowrap",
                                                        }}
                                                    >
                                                        Quitação
                                                    </Label>
                                                    <div style={{marginLeft: "-50px", marginTop: "25px"}}>
                                                        <Switch
                                                            className="switch"
                                                            checked={layoutBeingCreated.isQuitacao}
                                                            onChange={(e) =>
                                                                actions.setLayoutBeingCreated({
                                                                    ...layoutBeingCreated,
                                                                    isQuitacao: !layoutBeingCreated.isQuitacao,
                                                                })
                                                            }
                                                        />
                                                    </div>
                                                </>
                                                <>
                                                    <Label
                                                        style={{
                                                            fontWeight: "700",
                                                            color: "var(--color-preto)",
                                                            whiteSpace: "nowrap",
                                                        }}
                                                    >
                                                        Negativo
                                                    </Label>
                                                    <div style={{marginLeft: "-50px", marginTop: "25px"}}>
                                                        <Switch
                                                            className="switch"
                                                            checked={layoutBeingCreated.isNegativo}
                                                            onChange={(e) =>
                                                                actions.setLayoutBeingCreated({
                                                                    ...layoutBeingCreated,
                                                                    isNegativo: !layoutBeingCreated.isNegativo,
                                                                })
                                                            }
                                                        />
                                                    </div>
                                                </>
                                            </Col>
                                        )}
                                </Row>
                                <Mapeamento/>
                            </Col>
                        </Form>
                    </Col>
                </Card>
            </Col>
        </>
    );
}
